import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { map, tap } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AysDrgBaseRateStore } from './base-rate.store';
import { firstValueFrom, Observable } from 'rxjs';
import { BD_STATES } from '@bindoc-projects/geographic-domain-lib';
import { AysDrgBaseRate } from '@bindoc-projects/code-domain-lib';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';

@Injectable({
  providedIn: 'root',
})
export class AysDrgBaseRateService {
  private _httpClient = inject(HttpClient);
  private _environmentService = inject(BdAppEnvironmentService);

  private static _fromObj(obj: {
    baseRate: number;
    stateId: number;
    year: string;
  }): AysDrgBaseRate {
    return {
      year: parseInt(obj.year, 10),
      value: obj.baseRate,
      state: {
        id: obj.stateId,
        name: BD_STATES.find((it) => it.id === obj.stateId)?.name ?? null,
      },
    };
  }

  private _baseRates: { [year: string]: AysDrgBaseRate[] };
  private _store: AysDrgBaseRateStore;

  constructor() {
    this._store = new AysDrgBaseRateStore(this._environmentService.load(ApiEndpointKey.BD_DISTRICT_URL));
  }

  public index(): Promise<{ [year: string]: AysDrgBaseRate[] }> {
    let baseRateReq: Promise<{ [year: string]: AysDrgBaseRate[] }>;

    if (!this._baseRates) {
      baseRateReq = firstValueFrom(
        this._fetch().pipe(
          map((baseRatesResponse) =>
            this._parseBaseRatesResponse(baseRatesResponse),
          ),
          tap((res) => (this._baseRates = res)),
        ),
      );
    } else {
      baseRateReq = Promise.resolve(this._baseRates);
    }

    return baseRateReq;
  }

  private _fetch(): Observable<{
    [year: string]: { baseRate: number; stateId: number; year: string }[];
  }> {
    const url = this._store.index();

    return this._httpClient.get<{
      [year: string]: { baseRate: number; stateId: number; year: string }[];
    }>(url);
  }

  private _parseBaseRatesResponse(obj: {
    [year: string]: { baseRate: number; stateId: number; year: string }[];
  }): { [year: string]: AysDrgBaseRate[] } {
    const result: { [year: string]: AysDrgBaseRate[] } = {};
    Object.keys(obj).forEach((year) => {
      const baseRatesOfYear: {
        baseRate: number;
        stateId: number;
        year: string;
      }[] = obj[year];
      result[year] = baseRatesOfYear.map((value) =>
        AysDrgBaseRateService._fromObj(value),
      );
    });

    return result;
  }
}
